import {all} from 'redux-saga/effects';
import mailSagas from './Mail';
import toDoSagas from './Todo';
import contactSagas from './Contact';
import chatSagas from './Chat';
import authSagas from './Auth';
import previewCourseSaga from './PreviewCourse'
import RoleManagement from './RoleManagement'
import UserManagement from './UserManagement'

export default function* rootSaga(getState) {
  // debugger
  yield all([
    mailSagas(),
    toDoSagas(),
    contactSagas(),
    chatSagas(),
    authSagas(),
    previewCourseSaga(),
    RoleManagement(),
    UserManagement()
  ]);
}
